
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/vehiclebooking",
      function () {
        return require("private-next-pages/vehiclebooking/index.js");
      }
    ]);
  